// extracted by mini-css-extract-plugin
export default {"box":"filter_box__Zv4jV","title":"filter_title__BBA1O","input":"filter_input__2kUfd"};